import type { DecoBuildCtx } from "./define.ts";
import { rand } from "../color.ts";

// A small cluster of flowers — a thin stem topped with a rounded petal ball and a
// little center nub (rounded art style, plan 28 stage 4 — was stacked boxes).
// NOTE: this build doubles as the flower ITEM's ground-drop model, so it must
// stay tiny and grounded (stem base at y≈0).
const PETALS = [0xe85d75, 0xf2c14e, 0xe0e0e0, 0x9b6dd6, 0xff8c42];

// Geometry only — spawn metadata (weight/mapColor/habitat/sway/…) lives in
// content/decos/flower.json; this build is registered in src/model/coded.ts.
const build: (ctx: DecoBuildCtx) => void = ({ bone, ball, seed }) => {
    const count = 2 + Math.floor(rand(seed) * 3);
    for (let i = 0; i < count; i++) {
      const a = rand(seed + i * 9) * Math.PI * 2;
      const r = rand(seed + i * 9 + 1) * 0.35;
      const x = Math.cos(a) * r, z = Math.sin(a) * r;
      const h = 0.3 + rand(seed + i * 9 + 2) * 0.25;
      const petal = PETALS[Math.floor(rand(seed + i * 9 + 3) * PETALS.length)]!;
      bone(x, 0, z, x, h, z, 0.025, 0.02, 0x3f7a37);   // stem
      ball(x, h, z, 0.11, petal, 0.85);                // bloom (slightly squashed)
      ball(x, h + 0.03, z, 0.05, 0xf2c14e);            // center nub
    }
  };

export default build;
